import type { CurrentUserSearchCriteria } from "@/modules/user/api/types"

import { useQuery } from "@tanstack/react-query"

import { QUERY_CACHE_TIME, QUERY_STALE_TIME } from "@/modules/jobAds/client/constants"
import { CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY } from "@/modules/user/api/constants"
import { getCurrentUserSearchCriteria } from "@/modules/user/api/getCurrentUserSearchCriteria"
import { getCurrentUserSearchCriteriaKeys } from "@/modules/user/api/getUserQueryKeys"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

type UseCurrentUserSearchCriteriaFetch = {
  dataCurrentUserSearchCriteria?: CurrentUserSearchCriteria
  isLoadingCurrentUserSearchCriteria: boolean
  isSuccessCurrentUserSearchCriteria: boolean
  isErrorCurrentUserSearchCriteria: boolean
}

export const useCurrentUserSearchCriteriaFetch = (): UseCurrentUserSearchCriteriaFetch => {
  const { dataCurrentUser } = useCurrentUserFetch()
  const isLogged = !!dataCurrentUser?.isLogged

  const {
    data: dataCurrentUserSearchCriteria,
    isPending: isLoadingCurrentUserSearchCriteria,
    isSuccess: isSuccessCurrentUserSearchCriteria,
    isError: isErrorCurrentUserSearchCriteria,
  } = useQuery({
    enabled: !!isLogged && !!dataCurrentUser.attributes.isStudent,
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getCurrentUserSearchCriteria({}),
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getCurrentUserSearchCriteriaKeys({ isLogged, queryKey: CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY }),
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataCurrentUserSearchCriteria,
    isErrorCurrentUserSearchCriteria,
    isLoadingCurrentUserSearchCriteria,
    isSuccessCurrentUserSearchCriteria,
  }
}
